import { performRequest} from './api-handler';
import { URLS } from '../utility/urls'

export default () => {
    const { GET_PACKAGE_OPTION } = URLS;
    return {
        getPackageOptions: (body={}, method='get', id) =>
            performRequest( method ? method:'get', GET_PACKAGE_OPTION.replace(":packageId", id), body, 'userPortal'),
     }
}